<!-- GLOBAL FILTER FORM ELEMENT - TYPE: SELECT -->
<template>
   <div class="dyn-filter selectList"  v-if="isAuthorized(dashboardId)">
      <ods-select :id="field.id" :ref="field.id" v-if="field.schema.isVisible" v-model="selectedItem" :filterable="field.schema.isFilterable" :disabled=field.schema.isDisabled :multiple="field.schema.multi" :clearable="field.schema.isClearable" :selectLabel="$t(field.schema.i18nLabel)" :name="'' +field.id" :placeholder="$t(field.schema.i18nPlaceholder)"  @change="changeSelection($event)">
        <ods-option  v-for="item in realData" :key="item[field.schema.key ? field.schema.key: field.schema.options.value]" :label="item[field.schema.options.label]"  :value="item[field.schema.key ? field.schema.key: field.schema.options.value]"></ods-option>
      </ods-select>
      <ods-divider v-if="field.schema.isVisible && isAuthorized(dashboardId)" :direction="'horizontal'" :contentPosition="'center'"></ods-divider>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'selectList',
  props: {
    field: { type: Object, required: true },
    dashboardId: { type: String, required: true }
  },
  data: function () {
    return {
      selectedItem: [],
      cachedOptions: []
    }
  },
  computed: {
    ...mapGetters({
      getGlobalFilters: 'getGlobalFilters'
    }),
    filters () {
      return this.$parent.filters
    },
    realData () {
      var data = this.getGlobalFilters
      return data.filter(x => x.id === this.field.id).map(y => y.data)[0]
    },
    activeFilter () {
      var data = this.getGlobalFilters
      return data.filter(x => x.id === this.field.id).map(y => y.filter.activeFilter)[0]
    }
  },
  watch: {
    activeFilter: {
      // Watch for active Filter change and change value to avoid the select value when go disabled.
      deep: true,
      handler (activeFilter) {
        // console.log('activeFilter changed...', activeFilter, ' in Field: ', this.field.id)
        if (activeFilter) {
          this.selectedItem = activeFilter
          this.handleEnableDisableFields()
        } else {
          if (this.field.schema.isDisabled) { this.selectedItem = this.field.schema.multi ? [] : '' }
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'filterDataFilter',
      'sendFilter',
      'updateGlobalFilters'
    ]),
    // IS AUTHORIZED
    isAuthorized (dashboardId) {
      var authorizations = this.field.schema.authorizations || []
      var authorization = true
      if (authorizations.length > 0) {
        authorization = authorizations.filter(x => x === dashboardId).length > 0
        if (!authorization) { console.log('Filter Field ', this.field.id, ' is not authorized.') }
        return authorization
      } else {
        return true
      }
    },

    // INIT FIELD AND CONNECTIONS
    handleField () {
      // console.log('handleField() |--> ', this.field.id, ' dashboardId |--> ', this.dashboardId, ' Authorizations: ', this.field.schema.authorizations)
      // assign value, persistence filters
      if (this.field.schema.multi) {
        this.selectedItem = this.field.filter.activeFilter.length > 0 ? this.field.filter.activeFilter : []
      } else {
        this.selectedItem = this.field.filter.activeFilter !== '' ? this.field.filter.activeFilter : ''
      }
      // if has value and has related fields make filter between fields
      if (this.field.schema.filterTo.length > 0) {
        this.handleFilterFields()
        this.handleEnableDisableFields()
      }
    },

    // MAKE FILTER BETWEEN FIELDS
    handleFilterFields () {
      // console.log('handleFilterFields() |--> ', this.field.id)
      if (this.field.schema.filterTo && this.field.schema.filterTo.length > 0) {
        var items = this.field.schema.filterTo
        for (let i = 0; i < items.length; i++) {
          // console.log('|--> filter to update: ', items[i])
          this.filterDataFilter({ id: items[i], field: this.field.filter.field, value: this.selectedItem })
        }
      }
    },

    // HANDLE ENABLE OR DISABLE RELATED FIELDS
    handleEnableDisableFields () {
      // console.log('handleEnableDisableFields() |--> ', this.field.id)
      if (this.field.schema.filterTo.length > 0) {
        var fields = this.field.schema.filterTo
        var disabled = false
        var disabledActiveFilter = ''
        for (let i = 0; i < fields.length; i++) {
          if (this.field.schema.multi) {
            // multiple-value field
            disabled = this.field.filter.activeFilter.length === 0
            disabledActiveFilter = []
          } else {
            // single-value field
            disabled = this.field.filter.activeFilter === ''
            disabledActiveFilter = ''
          }
          // apply disabled state
          this.updateGlobalFilters({ id: fields[i], key: 'schema', elem: 'isDisabled', data: disabled })
          if (disabled) { this.updateGlobalFilters({ id: fields[i], key: 'filter', elem: 'activeFilter', data: disabledActiveFilter }) } // if disabled eliminate value
          // console.log('  |--> Field ', fields[i], 'disabled: ', disabled)
        }
      }
    },

    // CHANGE SELECTION: @change
    // filter other selectors if needed
    // |--> filter real data
    // |--> disable/enable other filters
    // send Filter and Update activeFilter property to generate persistence on filters on dashboard load.
    changeSelection (value) {
      // console.log('ChangeSelection(' + this.field.id + ') |--> Value: ', value, 'field: ', this.field.id, ' this field filter others: ', this.field.schema.filterTo)

      // activeFilter
      this.updateGlobalFilters({ id: this.field.id, key: 'filter', elem: 'activeFilter', data: value })

      // check filters
      this.handleFilterFields()

      // Enable/disable other fields
      this.handleEnableDisableFields()

      // Send Filter
      this.sendFilter({ filterId: this.field.id, value: value })
    }
  },
  mounted () {
    // READ FIELD INFO AND INIT THE FIELD OR MAKE OTHER ACTIONS (enable,disabled,visible,...) TO OTHER FIELDS
    // console.log('SelecList ON MOUNTED...')
    this.handleField()
  }
}
</script>
